module.exports = __webpack_public_path__ + "fonts/Lato-Semibold.8bb939e.eot";